import { FaCheck } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";

function MyRecipesComponent({ label, image, calories, ingredients, link }) {
  return (
    <div>
      <div className="container">
        <h2>{label}</h2>
      </div>
      <div className="container">
        <img className="tasty" src={image} alt="Tasty" />
      </div>

      <ul>
        {ingredients.map((item, index) => (
          <li key={index}>
            <FaCheck className="icon" />
            {item}
          </li>
        ))}
      </ul>

      <div className="container">
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="links"
        >
          See full recipe <FaArrowRight className="arrow" />
        </a>
      </div>

      <div className="container">
        <p className="calories">{calories.toFixed()} calories</p>
      </div>
    </div>
  );
}

export default MyRecipesComponent;
